import React, { useEffect } from 'react';

// Página exibida quando VITE_MAINTENANCE_MODE=true (ver index.tsx e README).
// Não depende de Firebase, Cloud Functions nem Mercado Pago.
const MaintenancePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Em manutenção | Currículo de Verdade';
  }, []);

  return (
    <main className="relative min-h-screen overflow-hidden bg-offWhite flex items-center justify-center px-4 py-12">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-cobalt opacity-10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-cyanMentor opacity-20 blur-3xl"
      />

      <div className="relative w-full max-w-xl rounded-2xl bg-white p-8 text-center shadow-xl sm:p-12">
        <div className="mb-8 flex items-baseline justify-center gap-1.5">
          <span className="font-display text-2xl font-bold text-cobalt">Currículo</span>
          <span className="font-display text-xl font-medium text-cyanMentor">de Verdade</span>
        </div>

        <div className="mx-auto mb-6 h-1 w-16 rounded-full bg-cyanMentor" />

        <h1 className="font-display text-2xl font-bold text-textGray sm:text-3xl">
          Estamos em manutenção
        </h1>

        <p className="mt-4 text-base leading-relaxed text-textGray/80">
          Estamos preparando melhorias na plataforma para gerar currículos ainda mais
          alinhados às vagas. Voltamos em breve.
        </p>

        <p className="mt-8 text-sm text-textGray/70">
          Dúvidas ou assinatura ativa? Fale com a gente:
          <br />
          <a
            href="mailto:suporte@curriculodeverdade.com.br"
            className="font-medium text-cobalt underline-offset-2 hover:underline"
          >
            suporte@curriculodeverdade.com.br
          </a>
        </p>

        <p className="mt-10 text-xs uppercase tracking-widest text-textGray/50">
          Quebrando barreiras invisíveis.
        </p>
      </div>
    </main>
  );
};

export default MaintenancePage;
